<template>
    <div class="login-form">
        <h2>{{ title }}</h2>

        <div class="text-link" v-if="!isLoginForm">
            <span>Ainda não tem cadastro?</span>
            <span class="link">
                <router-link to="cadastrar">Cadastre-se aqui</router-link>
            </span>
        </div>

        <div>
            <b-form @submit.stop.prevent="onSubmit" novalidate>
                <b-form-group id="input-group-1" label="E-mail de acesso:" label-for="email">
                    <b-form-input
                        id="email"
                        v-model="$v.form.email.$model"
                        type="email"
                        placeholder="Digite seu e-mail"
                        :state="validateState('email')"
                    ></b-form-input>

                    <b-form-invalid-feedback :state="validateState('email')">
                        Digite um e-mail válido
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="Senha" label-for="password" class="password-field">
                    <b-input-group>
                        <b-form-input
                            id="password"
                            v-model="$v.form.password.$model"
                            :type="showPassword ? 'text' : 'password'"
                            placeholder="Digite sua senha"
                            :state="validateState('password')"
                        >
                        </b-form-input>
                        <b-input-group-append class="btn-eye-password">
                            <b-button class="btn" @click="showPassword = !showPassword">
                                <i :class="`fas fa-${showPassword ? 'eye' : 'eye-slash'}`"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>

                    <b-form-invalid-feedback :state="validateState('password')">
                        Campo obrigatório
                    </b-form-invalid-feedback>
                </b-form-group>

                <div class="forgot-password">
                    <router-link :to="{ name: 'RecoverPassword' }">Esqueceu a senha?</router-link>
                </div>

                <b-button type="submit" :variant="getIsDarkTheme ? 'primary' : 'dark'" class="radius-6 submit"
                    >Entrar</b-button
                >
            </b-form>
        </div>

        <b-modal
            ref="warning-modal-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
        >
            <div class="content">
                <DangerMsgModal :msg="modalMessage" />
            </div>

            <div class="footer-buttons">
                <b-button variant="danger" @click="hideModal('warning-modal-ref')">Fechar</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import DangerMsgModal from '@/ui/modal/danger-msg-modal/DangerMsgModal'
import { AuthenticationApi } from '../../api/authentication'

const authenticationApi = new AuthenticationApi()

export default {
    components: { DangerMsgModal },
    data() {
        return {
            title: null,
            modalMessage: null,
            isLoginForm: false,
            showPassword: false,
            form: {
                email: null,
                password: null
            }
        }
    },
    validations: {
        form: {
            email: { required, email },
            password: { required }
        }
    },
    computed: {
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        }
    },
    methods: {
        ...mapActions(['setIsLoading']),
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        onSubmit(event) {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            this.setIsLoading(true)
            authenticationApi
                .login(this.form)
                .then(res => {
                    localStorage.removeItem('firstInfo')

                    if (res.data.id_permissao > 1) {
                        localStorage.setItem('authentication-admin', JSON.stringify(res.data))
                        this.$router.push({ name: 'DashboardAdminGridPage' })
                    } else {
                        localStorage.setItem('usuario', JSON.stringify(res.data))
                        this.$router.push({ name: 'DashboardGridPage' })
                    }
                })
                .catch(err => {
                    this.modalMessage = err.response.data.message
                    this.showModal('warning-modal-ref')
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        hideModal(refModalName) {
            this.$refs[refModalName].hide()
        }
    },
    created() {
        const routerName = this.$router.history.current.name

        if (routerName === 'LoginAdminForm') {
            this.title = 'Acesso Administrativo'
            this.isLoginForm = true
        } else {
            this.title = 'Olá, tudo bem?'
            this.isLoginForm = false
        }
    }
}
</script>

<style scope src="./LoginForm-light-theme.css"></style>
<style scope src="./LoginForm-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/components/login-form/LoginForm.vue